import { diseaseApi } from './disease.api';

export const diseaseActions = {
  async getDiseases({ commit }, payload) {
    try {
      commit('GET_DISEASES_LOADING');
      const response = await diseaseApi.getDiseases(payload);
      commit('GET_DISEASES_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_DISEASES_ERROR', error.response);
    }
  },
  async getDisease({ commit }, id) {
    try {
      commit('GET_DISEASE_LOADING');
      const response = await diseaseApi.getDisease(id);
      commit('GET_DISEASE_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_DISEASE_ERROR', error.response);
    }
  },
  async addDisease({ commit }, body) {
    try {
      commit('ADD_DISEASE_LOADING');
      const response = await diseaseApi.addDisease(body);
      commit('ADD_DISEASE_SUCCESS', response.data);
    } catch (error) {
      commit('ADD_DISEASE_ERROR', error.response);
    }
  },
  async updateDisease({ commit }, { id, body }) {
    try {
      commit('UPDATE_DISEASE_LOADING');
      const response = await diseaseApi.updateDisease(id, body);
      commit('UPDATE_DISEASE_SUCCESS', response.data);
    } catch (error) {
      commit('UPDATE_DISEASE_ERROR', error.response);
    }
  },
  async getCategories({ commit }) {
    try {
      commit('GET_CATEGORIES_LOADING');
      const response = await diseaseApi.getCategories();
      commit('GET_CATEGORIES_SUCCESS', response.data);
    } catch (error) {
      commit('GET_CATEGORIES_ERROR', error.response);
    }
  },
};
